import React, { FC } from 'react';

import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

import AppSync from 'config/AppSync';

const httpLink = createHttpLink({
  uri: AppSync.publicGraphqlEndpoint,
});

const authLink = setContext(() => ({
  headers: { 'X-Api-Key': AppSync.publicApiKey },
}));

const link = ApolloLink.from([authLink, httpLink]);
const cache = new InMemoryCache();
const client = new ApolloClient({ link, cache });

const ApolloPublic: FC = ({ children }) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
);

export default ApolloPublic;
